import { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

interface AddSubGroupProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const AddFeatureSubGroup: React.FC<AddSubGroupProps> = ({ open, setOpen }) => {
  const [name, setName] = useState<string>("");

  return (
    <Modal className="modal rejectReason_modal" open={open}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Sub Group</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="form">
            <div className="control_group">
              <label>Sub Group Name</label>
              <TextField
                fullWidth
                hiddenLabel
                placeholder="Enter Sub Group Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="control_group w_100">
              <label htmlFor="type">Field Type</label>
              <Select fullWidth hiddenLabel defaultValue="default">
                <MenuItem value="default" disabled>Select Field Type</MenuItem>
                <MenuItem value="0">Select</MenuItem>
                <MenuItem value="1">input</MenuItem>
                <MenuItem value="2">Checkbox</MenuItem>
                <MenuItem value="3">Radio</MenuItem>
                <MenuItem value="4">Yes/No</MenuItem>
              </Select>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddFeatureSubGroup;